/**
 * DevExtreme license key.
 * Set VITE_DEVEXTREME_LICENSE_KEY in .env (or .env.local) for production.
 * For development, an empty string uses evaluation mode.
 * Get a license from: https://js.devexpress.com/Buy/
 */
export const devextremeLicenseKey =
  typeof import.meta !== "undefined" && import.meta.env?.VITE_DEVEXTREME_LICENSE_KEY
    ? import.meta.env.VITE_DEVEXTREME_LICENSE_KEY
    : "";
